// frontend/src/components/courses/CourseFilterTabs.tsx

import { CourseCategory } from '../../types/courses.types';

interface FilterOption { value: CourseCategory | 'all'; label: string; icon: string; }

const FILTERS: FilterOption[] = [
  { value: 'all', label: 'Tümü', icon: '🌟' },
  { value: 'python', label: 'Python', icon: '🐍' },
  { value: 'matematik', label: 'Matematik', icon: '🧮' },
  { value: 'ingilizce', label: 'İngilizce', icon: '🇬🇧' },
  { value: 'turkce', label: 'Türkçe', icon: '📖' },
  { value: 'yapay_zeka', label: 'Yapay Zeka', icon: '🤖' },
  { value: 'web', label: 'Web', icon: '🌐' },
  { value: 'game', label: 'Oyun', icon: '🎮' },
  { value: 'veri_analizi', label: 'Veri Analizi', icon: '📊' },
];

interface CourseFilterTabsProps {
  active: CourseCategory | 'all';
  onChange: (value: CourseCategory | 'all') => void;
}

export function CourseFilterTabs({ active, onChange }: CourseFilterTabsProps) {
  return (
    <div className="courses-tabs" role="tablist">
      {FILTERS.map((f) => (
        <button
          key={f.value}
          role="tab"
          aria-selected={active === f.value}
          className={`courses-tab ${active === f.value ? 'active' : ''}`}
          onClick={() => onChange(f.value)}
        >
          {f.icon} {f.label}
        </button>
      ))}
    </div>
  );
}
